import React, { useId } from 'react';
type RangeSliderProps = {
  label: string;
  unit: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (v: number) => void;
};
export function RangeSlider({
  label,
  unit,
  min,
  max,
  step = 1,
  value,
  onChange
}: RangeSliderProps) {
  const id = useId();
  const pct = (value - min) / (max - min) * 100;
  return <div data-id="element-183" data-mp="1haoqjlzyywy2">
      <div className="flex items-baseline justify-between" data-id="element-184" data-mp="24yg1al5v31x8">
        <label htmlFor={id} className="font-mono text-[10.5px] tracking-[0.14em] text-graphite" data-id="element-185" data-mp="24yzjm2zfbsbs">
          {label}
        </label>
        <p className="text-[20px] font-semibold tabular-nums tracking-[-0.02em] text-ink" data-id="element-186" data-mp="29zdhwtb83nwm">
          {value}
          <span className="ml-1 text-[12px] font-medium text-graphite" data-id="element-187" data-mp="207pwb91cl132">{unit}</span>
        </p>
      </div>
      <div className="relative mt-1 h-9" data-id="element-188" data-mp="2nxk7lm60qhl7">
        <div className="absolute inset-x-0 top-1/2 h-[4px] -translate-y-1/2 rounded-full bg-ink/10" data-id="element-189" data-mp="2nwinytaxsmrv" />
        <div className="absolute left-0 top-1/2 h-[4px] -translate-y-1/2 rounded-full bg-ink" style={{
        width: `${pct}%`
      }} data-id="element-190" data-mp="2splgqz7w3s70" />
        <div className="pointer-events-none absolute top-1/2 h-6 w-6 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-ink bg-white shadow-[0_2px_6px_rgba(28,29,34,0.18)]" style={{
        left: `${pct}%`
      }} aria-hidden="true" data-id="element-191" data-mp="11e3fs6drgu6y" />
        <input id={id} type="range" min={min} max={max} step={step} value={value} onChange={e => onChange(Number(e.target.value))} className="precision-range absolute inset-0 h-full w-full cursor-pointer" aria-valuetext={`${value} ${unit}`} data-id="element-192" data-mp="16dod6cda8uhk" />
      </div>
      <div className="flex justify-between font-mono text-[9.5px] text-graphite/70" aria-hidden="true" data-id="element-193" data-mp="1p60ecvs79pq4">
        <span data-id="element-194" data-mp="3vvopzmp61s06">{min}</span>
        <span data-id="element-195" data-mp="3vx9ofnelpv3b">{max}</span>
      </div>
    </div>;
}